module.exports = __webpack_public_path__ + "static/cool-steel-8eacef2c9095aa4c0ad8b2c2651d8115.png";